"use client";

import { useEffect, useState } from "react";

export default function HeroVideo() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };

    let cancelled = false;
    const mount = () => {
      if (!cancelled) setShow(true);
    };

    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(mount, { timeout: 1500 });
    } else {
      setTimeout(mount, 800);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  if (!show) return null;

  return (
    <video
      src="/videos/hero-video.mp4"
      autoPlay
      muted
      loop
      playsInline
      preload="none"
      aria-hidden
      tabIndex={-1}
      className="absolute inset-0 z-0 h-full w-full object-cover opacity-25"
    />
  );
}
